// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class TokenOrigin {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.id = (_a = model.id) !== null && _a !== void 0 ? _a : null;
        this.name = (_b = model.name) !== null && _b !== void 0 ? _b : null;
        this.sourceId = (_c = model.sourceId) !== null && _c !== void 0 ? _c : null;
        this.sourceType = (_d = model.sourceType) !== null && _d !== void 0 ? _d : null;
        this.referenceOriginId = (_e = model.referenceOriginId) !== null && _e !== void 0 ? _e : null;
        this.referencePersistentId = (_f = model.referencePersistentId) !== null && _f !== void 0 ? _f : null;
        this.referenceResolutionFailed = (_g = model.referenceResolutionFailed) !== null && _g !== void 0 ? _g : null;
        this.referenceOriginRemote = (_h = model.referenceOriginRemote) !== null && _h !== void 0 ? _h : null;
        this.referenceOriginName = (_j = model.referenceOriginName) !== null && _j !== void 0 ? _j : null;
        this.key = (_k = model.key) !== null && _k !== void 0 ? _k : null;
    }
}
